import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { CheckoutService } from './checkout.service';
import { Subscription } from 'rxjs';

@Component({
   selector: 'app-checkout',
   template: `
      <div *ngIf="loading" class="checkout-loading">
         <mat-spinner diameter="48"></mat-spinner>
      </div>
      <div [hidden]="loading">
         <div id="checkout-buttons"></div>
         <div id="checkout-form"></div>
      </div>`,
})
export class CheckoutComponent implements OnInit, OnDestroy {
   payload: any;
   loading = true;

   private script?: HTMLScriptElement;
   private sub: Subscription = new Subscription();

   constructor(
      private router: Router,
      private checkout: CheckoutService,
   ) {
      this.payload = this.router.getCurrentNavigation()?.extras?.state?.payload ?? history.state?.payload;
   }

   ngOnInit() {
      if ( !this.payload ) { this.router.navigate([ '/' ]); return; }

      this.sub.add(this.checkout.getSession({
         account: this.payload.account,
         notes: this.payload.notes ?? '',
         payments: this.payload.payments,
         override: this.payload.override,
      }).subscribe({
         next: ({ jwt, payload }) => this.loadScript( payload.clientLibrary, payload.clientLibraryIntegrity, jwt ),
         error: () => { this.loading = false; this.router.navigate([ '/' ]); },
      }));
   }

   ngOnDestroy() {
      if ( this.script ) {
         this.script.remove();
         this.script = undefined;
      }
      this.sub.unsubscribe();
   }

   private loadScript( src: string, integrity: string, jwt: string ) {
      const script = document.createElement( 'script' );

      this.loading = false;
      script.src = src;
      script.integrity = integrity;
      script.crossOrigin = 'anonymous';
      script.onload = () => this.initializeCheckout(jwt).catch(err => console.error('Checkout initialization error:', err));

      document.head.appendChild( script );

      this.script = script;
   }

   private async initializeCheckout(jwt: string) {
      // Initialize Checkout.js with the payload
      const client = await (window as any).VAS.UnifiedCheckout(jwt);
      const checkout = await client.createCheckout();
      const result = await checkout.mount({
         paymentSelection: '#checkout-buttons',
         paymentScreen: '#checkout-form',
      });

      this.sub.add(this.checkout.getPaymentDetails(result).subscribe({
         next: (details) => {
            checkout.destroy();
            client.destroy();
            if (typeof details === 'boolean') {
               this.router.navigate(['/']);
            } else if (typeof details === 'string') {
               this.router.navigate(['/confirmation', details]);
            }
         },
         error: (err) => console.error('Payment details error:', err),
      }));
   }
}
